import { gql } from '@apollo/client'

export const GET_MY_CHANNEL = gql`
  query GetMyChannel($channelId: ID!) {
    myChannel(id: $channelId) {
      id
      name
      description
      followersCount
      allowComments
      publishAuthorName
    }
  }
`
